export const appLogConstants = {
  GETALL_REQUEST: 'APP_LOGS_GETALL_REQUEST',
  GETALL_SUCCESS: 'APP_LOGS_GETALL_SUCCESS',
  GETALL_FAILURE: 'APP_LOGS_GETALL_FAILURE',
  LEVELS_SUCCESS: 'APP_LOGS_LEVELS_SUCCESS',
  SHOW_REQUEST: 'APP_LOGS_SHOW_REQUEST',
  SHOW_SUCCESS: 'APP_LOGS_SHOW_SUCCESS',
  SHOW_FAILURE: 'APP_LOGS_SHOW_FAILURE',
  SHOW_CLEAR: 'APP_LOGS_SHOW_CLEAR',
};
